import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';

export const Route = createFileRoute('/roles')({
  component: () => <RouteGuard route="/roles" />,
});
